import React from "react"
import "../../../../ressource/css/custoPreview.css"
import { useLanguage } from "../../../../contexts/LanguageContext"

export default function HighlightLabel({ color = "#FFD600" }) {
  const { t } = useLanguage()

  return (
    <div className="shortways-highlight-row" style={{ justifyContent: "center" }}>
      <span className="shortways-highlight-label" style={{ "--highlight-color": color }}>
        {t("Sbs.sbsHighlightLabel")}
      </span>
    </div>
  )
}
